import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import {
  SensitiveData,
  SensitiveState,
  StoreKeys,
  initialState,
} from './sensitiveStore';

// In-memory only — MUST NOT be persisted (PII / SonarQube S5443).
const store = (set): SensitiveState => ({
  ...initialState,
  [StoreKeys.SENSITIVE_DATA]: {},
  [StoreKeys.SET_LOCATION_DATA]: (
    location: Partial<SensitiveData['location']>
  ) =>
    set((state: SensitiveState) => ({
      sensitiveData: {
        ...state.sensitiveData,
        location: { ...state.sensitiveData?.location, ...location },
      },
    })),
  [StoreKeys.CLEAR_SENSITIVE_DATA]: (defaultValues: SensitiveData = {}) =>
    set({ sensitiveData: { ...defaultValues } }),
});

export const useSensitiveStore = create(devtools(store));
